import { Box, styled, Tabs } from '@mui/material';

export const Container = styled(Box)({
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    padding: '24px',
    gap: '24px',
});

export const LeftPane = styled(Box)({
    flex: 3,
    display: 'flex',
    flexDirection: 'column',
});

export const RightPane = styled(Box)({
    flex: 1.2,
    backgroundColor: '#fafafa',
    borderRadius: '8px',
    padding: '16px',
    boxShadow: '0 0 10px rgba(0,0,0,0.05)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
});

export const TranscriptBox = styled(Box)({
    marginTop: '16px',
    padding: '16px',
    backgroundColor: '#fff',
    borderRadius: '8px',
    minHeight: '300px',
    border: '1px solid #eee',
    maxHeight: '250px',
    overflowY: 'auto',

    '& span.highlight': {
        backgroundColor: 'yellow',
        fontWeight: 'bold',
        borderRadius: '2px',
        padding: '0 2px',
    },
});

export const AudioControl = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
});

export const TabPanel = styled(Box)({
    marginTop: '16px',
});

export const ResponseBox = styled(Box)({
    padding: '16px',
    backgroundColor: '#e9f5e9',
    border: '1px solid #d4edda',
    borderRadius: '8px',
});

export const SummaryBox = styled(Box)({
    marginTop: '12px',
    backgroundColor: '#fff',
    padding: '12px',
    borderRadius: '6px',
    border: '1px solid #e0e0e0',
    lineHeight: 1.6,
});

export const StyledTabs = styled(Tabs)({
    backgroundColor: '#fff',
    borderRadius: '8px',
    marginTop: '12px',
});
